import isNil from 'lodash/isNil';

import type { AutocompleteAreaApiType } from 'app/shared/types/ApiResponseTypes';
class AutocompleteArea {
  areaId: string | null;
  longName: string | null;
  resourceId: string | null;
  type: string | null;

  constructor(res: AutocompleteAreaApiType = <AutocompleteAreaApiType>{}) {
    if (res) {
      this.areaId = !isNil(res.areaId) ? res.areaId : null;
      this.longName = !isNil(res.longName) ? res.longName : null;
      this.resourceId = !isNil(res.resourceId) ? res.resourceId : null;
      this.type = !isNil(res.type) ? res.type : null;
    } else {
      this.areaId = null;
      this.longName = null;
      this.resourceId = null;
      this.type = null;
    }
  }
}

export default AutocompleteArea;
